export function assertNever(obj: never) {
    throw new Error("Should never get here");
}


// WEBPACK FOOTER //
// ./src/utils/never.ts